export default "__VITE_ASSET__DzYJ9gNM__"